
let _ = require('./_.js');
let $ = jQuery;

_.states = require("./core/states.json");

// $.eventQueue shim -- ACE initializes this via jquery-event-queue package in bootstrap.js.
// WP doesn't have that package, so provide a minimal serial async queue.
if (!$.eventQueue) {
    let _eq_queue = [];
    let _eq_processing = false;
    async function _eq_process() {
        if (_eq_processing) return;
        _eq_processing = true;
        while (_eq_queue.length) {
            let fn = _eq_queue.shift();
            try { await fn(); } catch(e) { console.error('[eventQueue shim]', e); }
        }
        _eq_processing = false;
    }
    $.eventQueue = {
        push: function(fn) {
            _eq_queue.push(fn);
            Promise.resolve().then(_eq_process);
        }
    };
}

// Css
import '../../scss/auction/main.scss';

// Vendor
// import './vendor/galleria/azur/galleria.azur.css';
// window.Galleria = require('./vendor/galleria/galleria');
// require('./vendor/galleria/azur/galleria.azur');
// import './vendor/galleria/themes/azur/galleria.azur.js';

// ---- "Framework" includes - stuff not specific to Landproz / Auctioncast

// Functions are key
import './core/functions.js';
import './core/async.js';
import './core/timemanager.js';

// Data describes helper functions and parent classes for models
import './core/websocket.js';
import './core/data.js';
// import './core/fancyrow.js';

// Next is auto generated models
import './_model.js';

// Core helper functions
import './core/ajax.js';
import './core/ui_update.js';
import './core/ui_templates.js';

import './core/ui_smart_div.js';
import './core/components.js';
import './core/responsive.js';
import './core/responsive.js';
import './core/jq.js';
import './core/modal.js';
import './core/form.js';
import './core/reload.js';

// ---- Project specific includes below here ----

// Website code
import '../site/main.js';

// Project lib stuff
import './auctionui/auctionui.js';

import './auctioncast/auctioncast.js';
import './auctioncast/auctioncast-pip.js';

import './wp_lib/auction-bids.js';
import './wp_lib/backend-ajax.js';
import './wp_lib/components.js';
import './wp_lib/flash.js';
import './wp_lib/functions.js';
import './wp_lib/session.js';
import './wp_lib/activity.js';
import './wp_lib/websocket_ui.js';
import './wp_lib/web_session.js';
import './wp_lib/items.js';
import './wp_lib/notifications.js';
import './wp_lib/nouns.js';
import './wp_lib/login-from-header.js';
import './wp_lib/user-profile-modal.js';
import './wp_lib/wishlist.js';
import './wp_lib/my-auctions-modal.js';
import './wp_lib/backend-navigation.js';


import './notifications/outbid.js';
import './notifications/flash.js';
import './notifications/alert.js';
import './notifications/bid_denied.js';
import './notifications/bid_denied.js';
import './notifications/registration_denied.js';
import './notifications/registration_removed.js';
import './notifications/finalizing_choice.js';
import './notifications/standard_completed_non_winner.js';
import './notifications/standard_completed_winner.js';
import './notifications/choice_completed_non_winner.js';
import './notifications/choice_completed_winner.js';
import './notifications/item_won.js';
import './notifications/enterprise_low_bid_wf.js';
import './notifications/enterprise_low_bid_individual.js';
import './notifications/auction_completed_loser.js';
import './notifications/auction_completed_winner.js';
import './notifications/auction_completed_public.js';
import './notifications/auction_global.js';
import './notifications/force_accept_site_terms.js';

import '../../../parts/auction/auction-component.js'

_.is_frontend = true;

// Get backend URL from server-provided config
if (typeof window.landproz === 'undefined' || !window.landproz.LANDPROZ_API_URL) {
    throw new Error('[FATAL] LANDPROZ_API_URL not provided by server. Check wp_localize_script in theme.');
}

const backend_url = window.landproz.LANDPROZ_API_URL;
_.ajax_url_prefix = backend_url;
_.photo_url_prefix = backend_url;
_.is_prod = !window.location.hostname.includes('hanson.xyz');

// Production uses dedicated websocket server, others use ace.*/ws
if (backend_url === 'https://ace.landproz.com') {
    _.websocket_endpoint = 'wss://ws.landproz.com/ws';
} else {
    _.websocket_endpoint = backend_url.replace('https://', 'wss://') + '/ws';
}


// _.websocket_endpoint = 'wss://' + window.location.hostname + '/ws';
_.websocket_max_per_batch = 50;

let init_main = async function () {

    _.is_frontend = true;

    _.ac_state = { "flags": {} };

    // ---- Validate session is valid.  we must invalidate session before requesting any private data if it is not valid. -----
    await _.AuctionUI_Session.refresh();

    // ----Core inits----

    // The order of these matter.  It might be nice to refactor this so order doesn't matter in the future
    await _.Modal._init();
    await _.ac_websocket_ui_init();
    await _.ac_templates_init();
    await _.ac_responsive_init();
    await _.ac_smart_div_init();
    await _.ac_forms_init();
    await _.Notification_Auction_Global.init();

    // These should happen as soon as is reasonable
    await _.Login_From_Header.on_ready_init();
    await _.My_Auctions_Modal.init();

    // Initialize signup globally so register button works on all pages
    await _.AuctionUI_Signup.init();

    // Gets the unique browser fingerprint and logs this page load.
    _.Web_Session.log_activity();

    // ----Error handler----

    // Todo - send error reports via ajax
    window.addEventListener('unhandledrejection', function (event) {
        console.warn(event);
        if (!_.is_prod) {
            _.flash_ajax_error(event);
        }
    });

    // ----Submodule Init----

    // Init Theme
    await _.Landproz_Theme_Main.init();

    // Init lib notifications
    await _.Lib_Notifications.init();

    // Init auctioncast
    await _.AuctionCast_AuctionCast_Pip.init();
    await _.AuctionCast_AuctionCast.init();
    await _.AuctionUI.init();
    await _.ac_activity_init();
    await _.User_Profile_Modal.init();
    await _.Wishlist.init();
    await _.Backend_Navigation.init();


    // Refresh the UI and populate new components.
    await _.ui_update();

    // Load the session
    await _.AuctionUI_Session.refresh();

    // Must be done after gallery loads
    await _.AuctionCast_AuctionCast.start_listening_for_updates();


    // Kill all video elements if cachewarmer
    if (_.is_cachewarmer()) {
        $("video").remove();
    }
    
    // Mark page as fully initialized
    _.Login_From_Header.mark_page_initialized();
}

$(document).ready(async function () {
    await init_main();
});


// Simple function for setting a global application state / value
_.flag = function (flag, val = null) {
    if (!_.flags) {
        _.flags = {};
    }

    if (val !== null) {
        // Setter
        _.flags[flag] = val;
        _.ui_update();
    } else if (_.flags[flag]) {
        // getter
        return _.flags[flag];
    } else {
        // getter on unset value
        return false;
    }

}

_.clear_flag = function (flag) {
    if (!_.flags) {
        _.flags = {};
    }
    if (_.flags[flag]) {
        delete (_.flags[flag]);
        _.ui_update();
    }
}

/* Returns the full URL to the plugin directory. */
_.plugin_base_url = function () {
    if (!this._base_url) {
        this._base_url = JSON.parse(jQuery('#auctioncast-base-url').html());
    }
    return this._base_url;
}
